import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type SectionBoxStyledT = {
  isMobile: boolean;
};

export const getPopupContentStyle = (
  isMobile: boolean,
  isTablet: boolean,
  isDesktop: boolean,
  isLargeDesktop: boolean
) => ({
  width: isLargeDesktop ? '50%' : isDesktop ? '70%' : isTablet ? '90%' : isMobile ? '100%' : 'auto',
  height: isMobile ? '100%' : 'auto',
  padding: '1.5rem 0 2.25rem',
  maxHeight: window.matchMedia('(orientation: landscape)').matches ? '95vh' : '100vh',
  overflow: 'auto',
});

export const FormStyled = styled.form`
  width: 90%;
`;

export const FormElementWrapStyled = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

export const FormRowWrapStyled = styled(FlexContainer)`
  flex-direction: column;
  ${({ theme }) => `
    ${theme.devices.tablet} {
      flex-direction: row;
      align-items: flex-start;
      gap: 1rem;
    }
  `}
`;

export const TypographyTitleStyled = styled(Typography)`
  margin-bottom: 1.875rem;
`;

export const FlexContainerMessageStyled = styled(FlexContainer)`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 0 2.5rem 0.625rem;
    }
  `}
`;

export const ActionBtnStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }) => theme.fontSize['2xl']};

  &:first-child {
    margin-right: 1rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
      height: 38px;
      font-size: ${theme.fontSize.lg};
    }
  `}
`;

export const CtaContainerStyled = styled(FlexContainer)`
  margin-top: 1rem;
`;

export const SectionTitleStyled = styled(Typography)`
  font-weight: ${({ theme }) => theme.fontWeight['bold']};
  font-size: ${({ theme }) => theme.fontSize['lg']};
  padding-top: 10px;
`;

export const SectionBoxStyled = muiStyled(Box, {
  shouldForwardProp: prop => prop !== 'isMobile',
})<SectionBoxStyledT>(({ theme, isMobile }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  flexDirection: isMobile ? 'column' : 'row',
}));

export const SectionTitleBoxStyled = muiStyled(Box, {
  shouldForwardProp: prop => prop !== 'isMobile',
})<SectionBoxStyledT>(({ isMobile }) => ({
  width: isMobile ? '100%' : '20%',
  justifyItems: isMobile ? 'center' : 'start',
}));

export const SectionRowBoxStyled = muiStyled(Box, {
  shouldForwardProp: prop => prop !== 'isMobile',
})<SectionBoxStyledT>(({ theme, isMobile }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  width: '100%',
  flexDirection: isMobile ? 'column' : 'row',
  marginTop: '2px',
  marginBottom: '2px',
}));

export const SectionSelectBoxStyled = muiStyled(Box, {
  shouldForwardProp: prop => prop !== 'isMobile',
})<SectionBoxStyledT>(({ isMobile }) => ({
  flex: `${isMobile ? '1' : '0'} 1 40%`,
}));

export const SectionComponentBoxStyled = muiStyled(Box)(() => ({
  flex: '1 1 40%',
}));
